/* 🤖 this file was generated by svg-to-ts */
export const matIconRectangle: {
  name: 'rectangle';
  data: string;
} = {
  name: 'rectangle',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M2 4v16h20V4H2zm18 14H4V6h16v12z"/></svg>`
};
